import React, { useState } from "react";
import { ArrowLeft } from "react-feather";
import SallyLogo from "../../assets/logo-rewards-light.svg";
import AvatarMenu from "../AvatarMenu";
import BottomNav from "../BottomNav";
import QRAuthCode from "../QRAuthCode";
import { useCustomer } from "../../contexts/CustomerContext";
import styles from "./AppLayout.module.scss";

interface AppLayoutProps {
  /** Main heading rendered in the hero */
  title?: string;
  /** Smaller text above the title */
  subtitle?: string;
  /** When provided, renders a back button in the header */
  onBack?: () => void;
  children: React.ReactNode;
}

const AppLayout: React.FC<AppLayoutProps> = ({
  title,
  subtitle,
  onBack,
  children,
}) => {
  const { customer, signOut } = useCustomer();
  const [showQR, setShowQR] = useState(false);

  return (
    <div className={styles.Page}>
      <div className={styles.Hero}>
        <div className={styles.HeroTopRow}>
          {onBack ? (
            <button
              className={styles.BackBtn}
              type="button"
              onClick={onBack}
              aria-label="Go back"
            >
              <ArrowLeft size={20} />
            </button>
          ) : (
            <a
              href="https://sallypos.co"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.HeroLogoLink}
              aria-label="Sally POS"
            >
              <img src={SallyLogo} alt="Sally" className={styles.HeroLogo} />
            </a>
          )}
          <AvatarMenu customer={customer} onSignOut={signOut} />
        </div>
        {subtitle && <p className={styles.HeroSub}>{subtitle}</p>}
        {title && <h1 className={styles.HeroTitle}>{title}</h1>}
      </div>

      <div className={styles.Sheet}>{children}</div>

      <BottomNav onShowQR={() => setShowQR(true)} />
      {showQR && <QRAuthCode onClose={() => setShowQR(false)} />}
    </div>
  );
};

export default AppLayout;
